import { render } from "./404mobile.vue?vue&type=template&id=59ee34f1&scoped=true"
import script from "./404mobile.vue?vue&type=script&lang=js"
export * from "./404mobile.vue?vue&type=script&lang=js"

import "./404mobile.vue?vue&type=style&index=0&id=59ee34f1&scoped=true&lang=less"

import exportComponent from "/Users/user/Projects/simweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59ee34f1"]])

export default __exports__